<template>
  <div class="modal fade" id="destroy-plant" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent mb-0">
          <div class="block-header" :class="[headerColor]">
            <h3 class="block-title"><i class="fa fa-box-open text-white"></i> Destroy Plant</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close" @click.prevent="clearData()">
                <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="text-center alert-message-top" v-if="errorMsg">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="alert-message alert-danger alert-error-message">{{errorMsg}}</div>
              </div>
            </div>
          </transition>
          <div class="block-content">
            <div class="form-group required">
              <label class="control-label">Plant ID</label>
              <input v-model="id" name="plant_id" type="text" class="form-control form-control-alt" v-validate="'required'" data-vv-as="Plant ID" placeholder="Plant ID" />
              <p v-if="errors.has('plant_id')" class="errorMsg">{{ errors.first('plant_id') }}</p>
            </div>
            <div class="form-group">
              <label>Label</label>
              <input v-model="label" type="text" class="form-control form-control-alt" placeholder="Plant Label" />
            </div>
            <div class="form-group required">
              <label class="control-label">Reason Note</label>
              <input v-model="reasonNote" name="reason_note" type="text" class="form-control form-control-alt" v-validate="'required'" data-vv-as="Reason Note" placeholder="Reason note">
              <p v-if="errors.has('reason_note')" class="errorMsg">{{ errors.first('reason_note') }}</p>
            </div>
            <div class="form-group">
              <label>Actual Date</label>
              <input v-model="date" id="destroy-plant-date" type="text" class="form-control form-control-alt datepicker" placeholder="Date">
            </div>
          </div>
          <div class="block-content block-content-full text-right border-top button-loader">
            <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData()">Close</button>
            <button type="button" class="btn btn-sm btn-primary" @click.prevent="destroyPlant()" :bind:disabled="showModalLoader">
              <div><i class="fa fa-save mr-1"></i><span>Destroy</span></div>
                <span class="modal-loader" v-if="showModalLoader">
                  <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
                </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import $ from 'jquery';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';
Vue.use(VeeValidate, VueSpinners);

export default {
  name: 'DestroyPlant',
  data() {
    return {
      id: '',
      label: '',
      reasonNote: '',
      date: new Date().toJSON().slice(0,10),
      showModalLoader: false,
      headerColor: 'bg-info'
    };
  },
  mounted() {
    let vm = this, datepicker = $('#destroy-plant-date').datepicker({ format: 'yyyy-mm-dd', autoclose:true });
    datepicker.on('changeDate', (e) => {
      vm.date = e.format();
    });
  },
  components: {
    HashLoader
  },
  methods: {
    clearData() {
      this.id = '';
      this.label = '';
      this.reasonNote = '';
      this.headerColor = '';
      this.date = new Date().toJSON().slice(0,10);
      $('#destroy-plant-date').datepicker('update', this.date);
      this.$validator.reset();
    },
    setPlantDetails(plant, headerColor) {
      this.id = plant.Id;
      this.label = plant.Label;
      this.headerColor = headerColor;
    },
    destroyPlant() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (valid) {
          vm.showModalLoader = true;
          vm.errorMsg = '';
          helper.sendPostRequest('/plants/destroyplants', {
            Id: vm.id,
            Label: vm.label,
            ReasonNote: vm.reasonNote,
            ActualDate: vm.date
          }).then((data) => {
            if (data.status === 'success') {
              vm.$emit('loadPlants', true);
              jQuery('#destroy-plant').modal('hide');
              vm.clearData();
              vm.$emit('showSuccessMsg', data.message);
            } else {
              vm.errorMsg = data.message;
              vm.showModalLoader = false;
            }
          });
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// source/components/modals/DestroyPlant.vue